<template>
  <div class="my-images-picker" :class="list.length % 3 == 2 ? 'spec' : ''">
    <div class="m-images-list" v-for="(item, index) in list" :key="index">
      <el-image :src="item" :preview-src-list="list" :fit="'cover'"></el-image>
      <!-- <div class="m-images-cover" v-if="item.showOpt">
        <i class="m-images-del" @click="deletePicture($event, index)"></i>
      </div> -->
      <i class="m-images-del" @click="deletePicture($event, index)"></i>
    </div>
    <div
      class="m-images-btn"
      @click="addPicture"
      v-if="max == -1 || list.length < max"
    ></div>
  </div>
</template>

<script>
import { deleteQiNiuFiles } from "@/api/basic";
export default {
  name: "MyImagesPicker",
  data() {
    return {};
  },
  props: {
    list: [],
    max: {
      type: Number,
      default: -1,
    },
  },
  methods: {
    addPicture() {
      const { list } = this;
      this.$.image
        .choose()
        .then((res) => {
          return this.$.http.uploadImage(res);
        })
        .then((res) => {
          const { code, data } = res;
          if (code == 200) {
            this.$emit("update:list", [...list, data.url]);
          }
        });
    },
    showOpt(index) {
      const { list } = this;
      list.forEach((item, cindex) => {
        if (cindex == index) item.showOpt = true;
        else item.showOpt = false;
      });
      this.$emit("update:list", list);
      this.$forceUpdate();
    },
    deletePicture(ev, index) {
      ev.stopPropagation();
      deleteQiNiuFiles({ path: this.list[index] })
        .then((res) => {
          this.list.splice(index, 1);
        })
        .catch(() => {
          this.list.splice(index, 1);
        });
    },
  },
};
</script>

<style>
.m-images-btn {
  width: 2rem;
  height: 2rem;
  background: url("../../../../assets/images/mobile/upload_images.png")
    no-repeat center;
  background-size: contain;
  flex-shrink: 0;
}

.m-images-cover {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.1rem;
}
.m-images-del {
  width: 0.5rem;
  height: 0.5rem;
  display: block;
  background: url("../../../../assets/images/mobile/icon_close_img.png")
    no-repeat center;
  background-size: contain;
  position: absolute;
  top: 0;
  right: 0;
}

.m-images-list .el-image {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.1rem;
  margin: auto;
  display: block;
}

.m-images-list {
  display: block;
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;
  width: 1.8rem;
  height: 1.8rem;
  position: relative;
  border: 1px solid #999;
  padding: 0.1rem;
}
.my-images-picker {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.my-images-picker::after {
  display: block;
  content: "";
  width: 2rem;
  height: 2rem;
}
.my-images-picker.spec {
  margin-bottom: -2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile/components/MyImagesPicker/index.vue